export const ALERT_STATUS = [
  {
    label: 'Identificado',
    value: 'IDENTIFIED',
    userCanSelect: false,
  },
  {
    label: 'Em aberto',
    value: 'OPEN',
    userCanSelect: true,
  },
  {
    label: 'Em atendimento',
    value: 'INVESTIGATING',
    userCanSelect: true,
  },
  {
    label: 'Concluido',
    value: 'CONCLUDED',
    userCanSelect: true,
  },
  {
    label: 'Inconclusivo',
    value: 'INCONCLUSIVE',
    userCanSelect: true,
  },
  {
    label: 'Falso positivo',
    value: 'FALSE-POSITIVE',
    userCanSelect: true,
  },
  {
    label: 'Conclusão automática',
    value: 'AUTO-CONCLUDED',
    userCanSelect: false,
  },
  {
    label: 'Falso positivo automático',
    value: 'AUTO-FALSE-CONCLUDED',
    userCanSelect: false,
  },
]
